import {
  COLOR_MAP_CUSTOM_ROUTE_1,
  COLOR_MAP_CUSTOM_ROUTE_1_OUTLINE,
  COLOR_MAP_CUSTOM_ROUTE_2,
  COLOR_MAP_CUSTOM_ROUTE_2_OUTLINE,
  COLOR_MAP_CUSTOM_ROUTE_3,
  COLOR_MAP_CUSTOM_ROUTE_3_OUTLINE,
  COLOR_MAP_CUSTOM_ROUTE_4,
  COLOR_MAP_CUSTOM_ROUTE_4_OUTLINE,
  COLOR_MAP_ROUTE,
  COLOR_MAP_ROUTE_OUTLINE
} from '@alltrails/denali/tokens';

export const LINE_COLORS = [COLOR_MAP_ROUTE, COLOR_MAP_CUSTOM_ROUTE_1, COLOR_MAP_CUSTOM_ROUTE_2, COLOR_MAP_CUSTOM_ROUTE_3, COLOR_MAP_CUSTOM_ROUTE_4];
const LINE_COLOR_ORDER = LINE_COLORS.reduce((acc, color, index) => {
  acc[color] = index;
  return acc;
}, {});

const LINE_COLOR_MAP = {
  ['#428a13']: COLOR_MAP_ROUTE,
  ['#ff0000']: COLOR_MAP_CUSTOM_ROUTE_1,
  ['#f5d24b']: COLOR_MAP_CUSTOM_ROUTE_2,
  ['#219ad8']: COLOR_MAP_CUSTOM_ROUTE_3,
  ['#be50c8']: COLOR_MAP_CUSTOM_ROUTE_4
};

const LINE_OUTLINE_COLORS = {
  [COLOR_MAP_ROUTE]: COLOR_MAP_ROUTE_OUTLINE,
  [COLOR_MAP_CUSTOM_ROUTE_1]: COLOR_MAP_CUSTOM_ROUTE_1_OUTLINE,
  [COLOR_MAP_CUSTOM_ROUTE_2]: COLOR_MAP_CUSTOM_ROUTE_2_OUTLINE,
  [COLOR_MAP_CUSTOM_ROUTE_3]: COLOR_MAP_CUSTOM_ROUTE_3_OUTLINE,
  [COLOR_MAP_CUSTOM_ROUTE_4]: COLOR_MAP_CUSTOM_ROUTE_4_OUTLINE
};

export const getLineColor = (color: string) => {
  const lookupColor = color.toLowerCase();
  return LINE_COLOR_MAP[lookupColor] || lookupColor;
};

export const getLineOutlineColor = (color: string) => {
  const lookupColor = getLineColor(color.toLowerCase());
  return LINE_OUTLINE_COLORS[lookupColor] || lookupColor;
};

export const getNextColor = (color: string) => {
  const colorIndex = LINE_COLOR_ORDER[color];
  return LINE_COLORS[(colorIndex + 1) % LINE_COLORS.length];
};

export const getLineColorBySegmentIndex = (index: number) => LINE_COLORS[index % LINE_COLORS.length];
